import React, { Component, Fragment } from "react";
import { formatter } from "../../../../core/utilities/formatter";
import Button from "../../../components/Button2";
import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";

class SuccessfulPurchase extends Component {
    renderNonTrialSuccessMessage() {
        const { message, plan } = this.props;
        if (message) {
            return message;
        }
        return (<Fragment>You have successfully upgraded to <span>{formatter.capitalizeFirstLetter(plan)}</span>.</Fragment>);
    }

    render() {
        const { plan, showTrial, billingDate, trialExpirationDate, callToActionText, message } = this.props;

        if (showTrial) {
            return (
                <BeautifulDialog preventClose={true}>
                    <DialogContent>
                        <div id="successful_purchase">
                            <div id="big_icon">
                                <i className="micon">check</i>
                            </div>
                            <div id="message">Great! You've just started your 14-day free trial for Beautiful.ai {formatter.capitalizeFirstLetter(plan)}.</div>
                            <div className="receipt">
                                Cancel anytime before {trialExpirationDate} and you will not be charged.
                            </div>
                            <Button onClick={this.props.onCallToActionClick} label={callToActionText} />
                        </div>
                    </DialogContent>
                </BeautifulDialog>
            );
        } else {
            return (
                <BeautifulDialog preventClose={true}>
                    <DialogContent>
                        <div id="successful_purchase">
                            <div id="big_icon">
                                <i className="micon">check</i>
                            </div>
                            <div id="message">
                                {this.renderNonTrialSuccessMessage()}
                            </div>
                            <div className="receipt">A receipt will be sent to your email shortly</div>
                            <Button onClick={this.props.onCallToActionClick} label={callToActionText} />
                        </div>
                    </DialogContent>
                </BeautifulDialog>
            );
        }
    }
}

export default SuccessfulPurchase;
